import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiVianenSchipholPage() {
  return (
    <CityAirportTemplate
      city="Vianen"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={62.50}
      distance="52 km"
      duration="42-48 minuten"
    />
  );
}
